
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 15","d":"M8 0a8 8 0 11-8 8 8 8 0 018-8z"}}),_c('path',{attrs:{"data-name":"Path 7","d":"M10.936 10.936a.583.583 0 01-.824 0L8.053 8.875l-2.059 2.059a.583.583 0 11-.824-.824l2.059-2.059-2.054-2.057a.583.583 0 11.824-.824l2.059 2.059 2.054-2.054a.583.583 0 11.824.824L8.875 8.053l2.059 2.059a.583.583 0 01.002.824z","fill":"#e0e0e0"}})])
          )
        }
      }
    